import { render, staticRenderFns } from "./AddFormsModal.vue?vue&type=template&id=43571b50&"
import script from "./AddFormsModal.vue?vue&type=script&lang=js&"
export * from "./AddFormsModal.vue?vue&type=script&lang=js&"
import style0 from "./AddFormsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports